import Gooey, { mount } from '@srhazi/gooey';

import { LightApp } from './webmidi-visualization/LightApp';

import './webmidi-visualization.css';

const app = document.getElementById('app');
if (!app) {
    alert('RUH ROH, no #app element found');
} else {
    mount(app, <LightApp />);
}
